module.exports = __webpack_public_path__ + "img/person-third.2d9b6048.svg";